// extracted by mini-css-extract-plugin
module.exports = {"alert":"PageBestViewedAlert_alert__3GMA6","alert--content":"PageBestViewedAlert_alert--content__2V8FQ","alert--content--icon":"PageBestViewedAlert_alert--content--icon__3PF9W"};